import { useEffect } from 'react';
export function useScrollEventListener(listener) {
  useEffect(() => {
    window.addEventListener('scroll', listener, true);
    return () => window.removeEventListener('scroll', listener, true);
  }, [listener]);
}